import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col, Tabs, Tab, Form, Button } from "react-bootstrap";
import Sidebar from "../../components/Sidebar";
import Breadcrumbs from "../Users/Breadcrumbs";
import { useLocation, useParams } from "react-router-dom";
import { BettingHistoryTab } from "./BettingHistoryTab";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import AuthContext from "../../context/AuthContext";
import { toast } from "react-toastify";
import moment from "moment";
import { BettingHistoryTabNew } from "./BettingHistoryTabNew";
import { isEmpty } from "lodash";

const BattingHistoryNew = () => {
  const params = useParams();
  const location = useLocation();
  let { user ,setAccountError} = useContext(AuthContext);
  const [key, setKey] = useState("Exchange");
  const [pageCount, setPageCount] = useState(0);
  const [viewpage, setViewPage] = useState(0);
  var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const [filter, setFilter] = useState({
    toPeriod: currentDate,
    fromPeriod: previousDate,
    userType: user?.userType,
    id: user?._id,
    userName: "",
    page: 1,
    limit: 100,
    status: "completed",
  });
  const [data, setData] = useState([]);
  const getData = async (type = "search") => {
    if (filter.filterByDay != "") {
      if (filter.filterByDay == "today") {
        filter.fromPeriod = currentDate;
        filter.toPeriod = currentDate;
      }
      if (filter.filterByDay == "yesterday") {
        filter.fromPeriod = previousDate;
        filter.toPeriod = currentDate;
      }
    }
    let path = apiPath.betHistory;

    let obj = {
      ...filter,
      userType: isEmpty(filter?.userName) ? user?.userType : "",
      id: isEmpty(filter?.userName) ? user?._id : "",
      betType:
        key == "Exchange"
          ? "betfair"
          : key == "FancyBet"
          ? "fancy"
          : key == "Sportsbook"
          ? "sportBook"
          : key == "BookMaker"
          ? "bookmaker"
          : key == "Tie"
          ? "tie"
          : key == "Toss"
          ? "toss"
          : key == "parlay"
          ? "parlay"
          : "casino",
    };

    const { status, data: response_users } = await apiGet(path, obj);
    if (status === 200) {
      if (response_users.success) {
        setData(response_users.results);    if (response_users.results.data?.length == 0) {
          setAccountError(true);
        } else {
          setAccountError(false);
        }
      }
    }
  };

  const handlePageClick = (event) => {
    setFilter((prevState) => {
      return {
        ...prevState,
        page: event.selected + 1,
      };
    });
    setViewPage(event.selected);
  };

  // useEffect(() => {
  //   getData();
  // }, [key]);
  
  return (
    <div className="top-header-inner">
      <section className="py-4 main-inner-outer">
        <Container fluid>
          <div className="accout_cols_outer">
            <div className="right_side">
              <div style={{overflowX:"hidden"}} className="inner-wrapper">
                <h2 className="common-heading">Betting History</h2>
                <div
                  className="d-flex align-items-center mb-2"
                  style={{
                    borderBottom: "1px solid #e0e0e0",
                    paddingBottom: "10px",
                  }}
                >
                  <Form.Control
                    placeholder="enter betId...."
                    style={{
                      height: "27px",
                      width: "220px",
                      fontSize: "13px",
                      marginRight: "10px",
                    }}
                    onChange={(e) =>
                      setFilter((prev) => {
                        return { ...prev, betId: e.target.value };
                      })
                    }
                    value={filter?.betId}
                  />
                  <Button
                    style={{ marginRight: "10px" }}
                    onClick={() => getData()}
                    className="theme_light_btn theme_dark_btn"
                  >
                    Submit
                  </Button>
                  <p className="p-0 m-0">
                    Multiple of betIds querie can be entered (e.g. 12,345,6789)
                  </p>
                </div>
                <Form.Control
                  placeholder="enter userId...."
                  style={{
                    height: "25px",
                    width: "170px",
                    marginBottom: "10px",
                    fontSize: "13px",
                  }}
                  onChange={(e) =>
                    setFilter((prev) => {
                      return { ...prev, userName: e.target.value };
                    })
                  }
                  value={filter?.userName}
                />
                <div className="common-tab">
                  <Tabs
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => {
                      setKey(k);
                      // setFilter({
                      //   page: 1,
                      //   limit: 100,
                      //   toPeriod: "",
                      //   fromPeriod: "",
                      //   filterByDay: "",
                      //   userType: "user",
                      //   id: "",
                      // });
                    }}
                  >
                    <Tab eventKey="Exchange" title="Exchange">
                      {key === "Exchange" && (
                        <BettingHistoryTabNew
                          url={location.pathname.split("/")[1]}
                          title={key}
                          betType={"betfair"}
                          setFilter={setFilter}
                          filter={filter}
                          data={data}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                        />
                      )}
                    </Tab>
                    <Tab eventKey="FancyBet" title="FancyBet">
                      {key === "FancyBet" && (
                        <BettingHistoryTabNew
                          url={location.pathname.split("/")[1]}
                          title={key}
                          betType={"fancy"}
                          setFilter={setFilter}
                          filter={filter}
                          data={data}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                        />
                      )}
                    </Tab>
                    <Tab eventKey="Sportsbook" title="Sportsbook">
                      {key === "Sportsbook" && (
                        <BettingHistoryTabNew
                          url={location.pathname.split("/")[1]}
                          title={key}
                          betType={"sportBook"}
                          setFilter={setFilter}
                          filter={filter}
                          data={data}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                        />
                      )}
                    </Tab>
                    <Tab eventKey="BookMaker" title="BookMaker">
                      {key === "BookMaker" && (
                        <BettingHistoryTabNew
                          url={location.pathname.split("/")[1]}
                          title={key}
                          betType={"bookmaker"}
                          setFilter={setFilter}
                          filter={filter}
                          data={data}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                        />
                      )}
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default BattingHistoryNew;
